import { createStore } from 'vuex'
import getters from './getters'
import app from './modules/app'
// eslint-disable-next-line import/no-cycle
import user from './modules/user'
import style from './modules/style'
import investmentStatistics from './modules/investmentStatistics'

const store = createStore({
  modules: {
    app,
    user,
    style,
    investmentStatistics
  },
  getters
})

export default store
